// Generated by genversion.
export const version = '1.23.0-next.24'
